var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgRating(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "star_a0z8ubeg0kzq 1",
    clipPath: "url(#clip0_5302_36064)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M19.1217 7.77591C19.0109 7.41961 18.7245 7.16452 18.3746 7.11192L13.1721 6.32439L10.8287 1.3752C10.6698 1.04121 10.3528 0.833984 10.0022 0.833984C9.65161 0.833984 9.33463 1.04124 9.17652 1.37442L6.83305 6.32443L1.63057 7.11195C1.28072 7.16456 0.994282 7.41965 0.883537 7.77595C0.770501 8.14021 0.862162 8.53082 1.12261 8.79543L4.87456 12.608L3.9847 18.0147C3.93658 18.3057 4.0122 18.5998 4.19169 18.8222C4.46667 19.1625 4.93872 19.2646 5.31836 19.0573L10.0022 16.4907L14.6861 19.0573C14.8197 19.1307 14.9626 19.1673 15.11 19.1673C15.3796 19.1673 15.6355 19.0414 15.8127 18.8214C15.9922 18.599 16.0678 18.3048 16.0197 18.0139L15.1299 12.6071L18.8826 8.7954C19.143 8.53 19.2347 8.13939 19.1217 7.77591ZM18.3486 8.22469L14.4523 12.1831C14.3622 12.2747 14.321 12.4071 14.3423 12.5362L15.2658 18.1494C15.278 18.2259 15.2513 18.2785 15.2269 18.3088C15.1971 18.3471 15.1528 18.3702 15.11 18.3702L10.1802 15.6872C10.1244 15.6569 10.0633 15.6417 10.0022 15.6417C9.94109 15.6417 9.88001 15.6569 9.82501 15.6872L4.89443 18.3702C4.85165 18.3702 4.80736 18.3471 4.77603 18.3081C4.75157 18.2778 4.72486 18.2251 4.73707 18.1486L5.66055 12.5354C5.68193 12.4063 5.64068 12.274 5.55056 12.1823L1.65499 8.22391C1.58091 8.149 1.59924 8.05813 1.60991 8.02226C1.62212 7.98239 1.65574 7.91386 1.73977 7.90108L7.14087 7.08326C7.26536 7.06491 7.37306 6.98361 7.42806 6.86565L9.86089 1.7283C9.94034 1.5593 10.0625 1.5593 10.142 1.7283L12.5748 6.86561C12.6306 6.98278 12.7383 7.06487 12.862 7.08322L18.2631 7.90105C18.3479 7.91379 18.3815 7.98314 18.3937 8.02222C18.4052 8.05809 18.4228 8.14978 18.3486 8.22469Z",
    fill: "#ffffff",
    stroke: "#ffffff",
    strokeWidth: 0.3
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5302_36064"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRating);
export default __webpack_public_path__ + "static/media/rating.55df3ac754fb4d50cfb7828e52b11b24.svg";
export { ForwardRef as ReactComponent };